import React from "react";
import Container from "../ui/Container";
import HomeAppCtas from "./HomeAppCtas";
import BrokerConnectionsStrip from "./BrokerConnectionsStrip";

// Home hero SVGs from Untitled design (1).zip — 1=wave, 2=city diorama.
// Declared SVG size 1512×828 (viewBox 1134×621). Scale by width only.
const HERO_DIORAMA_SRC = "/images/home-hero-diorama.svg";
const HERO_DIORAMA_W = 1512;
const HERO_DIORAMA_H = 828;

const HERO_WAVE_SRC = "/images/home-hero-wave.svg";
const HERO_WAVE_W = 1512;
const HERO_WAVE_H = 828;

const PROCESS_STEPS = [
  {
    n: "01",
    title: "Build your rules",
    body: "Turn your ideas into clear conditions.",
  },
  {
    n: "02",
    title: "Test on history",
    body: "See how your strategy would have performed.",
  },
  {
    n: "03",
    title: "Run in paper",
    body: "Let it trade in the cloud and get fill notifications.",
  },
];

export default function LifeMovesHero() {
  return (
    <section className="relative overflow-x-clip bg-bg0">
      <div className="hero-wave-bg" aria-hidden="true">
        <img
          src={HERO_WAVE_SRC}
          alt=""
          width={HERO_WAVE_W}
          height={HERO_WAVE_H}
          decoding="async"
        />
      </div>

      <Container className="relative z-10 pt-10 text-center md:pt-12 lg:pt-14">
        <h1 className="relative isolate mx-auto max-w-[min(46rem,calc(100%-1.5rem))] text-[clamp(2.35rem,0.25rem+4.4vw,4.75rem)] font-semibold leading-[1.02] tracking-display text-ink sm:max-w-none">
          Life moves.
          <br />
          <span className="whitespace-normal sm:whitespace-nowrap">
            <span className="relative">
              <span
                aria-hidden="true"
                className="absolute -inset-x-[0.12em] inset-y-[0.16em] -z-10 rounded-md bg-[#d7f4f6]"
              />
              Your strategy
            </span>{" "}
            stays with it.
          </span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-muted md:text-lg">
          Build your rules, test them on history, and run them in cloud paper
          trading—your holdings, strategies, and fill notifications all connected.
        </p>
        <HomeAppCtas align="center" className="mt-7" />
      </Container>

      <img
        src={HERO_DIORAMA_SRC}
        alt="Stratify on iPhone above a connected city scene of building a rule, connecting it, and a paper fill"
        width={HERO_DIORAMA_W}
        height={HERO_DIORAMA_H}
        fetchpriority="high"
        loading="eager"
        decoding="async"
        className="hero-diorama relative z-[1] mt-4 md:mt-5"
      />

      <Container className="relative z-10 pb-6 md:pb-8">
        <ol className="grid gap-8 border-t border-ink/8 pt-8 text-left sm:grid-cols-3 sm:gap-6 md:pt-10">
          {PROCESS_STEPS.map((step) => (
            <li key={step.n}>
              <div className="flex items-baseline gap-2 text-[12px] font-semibold tracking-tight text-ink">
                <span className="text-muted">{step.n}</span>
                <span>{step.title}</span>
              </div>
              <p className="mt-2 max-w-xs text-sm leading-relaxed text-muted">{step.body}</p>
            </li>
          ))}
        </ol>
        <BrokerConnectionsStrip />
        <blockquote className="mx-auto mt-8 max-w-4xl text-center md:mt-10">
          <p className="text-[clamp(1.65rem,0.6rem+3.2vw,3.25rem)] font-semibold leading-[1.15] tracking-display text-ink">
            &ldquo;We don&apos;t have to be smarter than the rest. We have to be more
            disciplined than the rest.&rdquo;
          </p>
          <footer className="mt-4 text-sm font-medium tracking-wide text-muted md:text-base">
            — Warren Buffett
          </footer>
        </blockquote>
      </Container>
    </section>
  );
}
